import { render, staticRenderFns } from "./HelpCenterSideBar.vue?vue&type=template&id=6b932534&scoped=true"
import script from "./HelpCenterSideBar.vue?vue&type=script&lang=js"
export * from "./HelpCenterSideBar.vue?vue&type=script&lang=js"
import style0 from "./HelpCenterSidebar.style.scss?vue&type=style&index=0&id=6b932534&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b932534",
  null
  
)

export default component.exports